<section class="theme-linked-brands-popover">
  <h4>{{ 'SETTINGS_THEME.LINKED_BRANDS.POPOVER_TITLE' | translate }}</h4>
  <ul class="theme-linked-brands-popover__list">
    @for (brand of brands(); track brand.id) {
      <li class="theme-linked-brand">
        @if (brand.logoUrl) {
          <img class="theme-linked-brand__logo" [src]="brand.logoUrl" alt="" loading="lazy" />
        } @else {
          <span class="theme-linked-brand__logo-placeholder" aria-hidden="true">
            {{ linkedBrandInitials(brand.name) }}
          </span>
        }
        <span class="theme-linked-brand__name">{{ brand.name }}</span>
      </li>
    }
  </ul>
</section>
